import { useMutation, useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react'
import { baseURL } from '../../utils/Axios';
import axios from 'axios';
import toast from 'react-hot-toast';

function ImageContainer({ onSuccess }) {

    const [isOnDrag, setIsOnDrag] = useState(false)

    const queryClient = useQueryClient();

    const onDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOnDrag(true)
    }

    // uploading image

    const mutation = useMutation({
        mutationKey: ['uploading'],
        mutationFn: async (payload) => {
            const res = await axios.post(`${baseURL}/upload`, payload);
            return res.data;
        },
        onMutate: () => {
            toast.dismiss()
            toast.loading("File uploading")
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['medias'] })
            toast.dismiss()
            toast.success('File Uploaded')
            onSuccess(data)
        },
        onError: (error) => {
            toast.dismiss()
            toast.error(error?.response?.data || "Error while uploading file")
        }
    })


    const upLoadFile = (e) => {
        e.preventDefault()

        const files = e.target.files;
        if (files?.length) {

            const formData = new FormData();

            Object.keys(files).forEach(key => {
                formData.append('file', files[key])
            })

            mutation.mutate(formData)
            return;
        }
    }

    const onDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const files = e.dataTransfer.files;

        if (files?.length) {
            const formData = new FormData();

            Object.keys(files).forEach(key => {
                formData.append('file', files[key])
            })
            mutation.mutate(formData)
            return;
        }
    }


    return (
        <div className='relative w-full cursor-pointer'>
            <label
                onDragOver={onDragOver}
                onDragLeave={() => setIsOnDrag(false)}
                onDrop={onDrop}
                htmlFor="file"
                className={`border p-5 py-7 text-center border-dashed  block w-full 
                rounded-xl space-y-3 bg-[#fcfcfc] cursor-pointer ring-2 ring-offset-1 
                ${isOnDrag ? 'border-green-500 ring-gray-300/50' : 'border-gray-500 ring-transparent'}`}
            >
                <div className="flex w-full justify-center items-center gap-2">
                    <label
                        htmlFor='file'
                        className='text-xs px-3 py-1.5 rounded-md bg-white border shadow cursor-pointer'
                    >
                        Add media
                    </label>
                </div>

                <h3 className="text-gray-500 text-xs text-center">Drag, or drop your images here</h3>

            </label>
            <input multiple type="file" className='hidden' id='file' onChange={upLoadFile} />
        </div>
    )
}

export default ImageContainer